import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#59AD3B",
      d: "M.273 28.377v-7.703c0-2.38.416-4.833 1.247-7.364a31.942 31.942 0 0 1 3.568-7.306C6.636 3.663 8.392 1.66 10.355 0l6.797 4.248a39.995 39.995 0 0 0-3.738 7.533c-.944 2.606-1.416 5.551-1.416 8.836v7.76H.273Zm18.579 0v-7.703c0-2.38.415-4.833 1.246-7.364a31.938 31.938 0 0 1 3.568-7.306C25.214 3.663 26.97 1.66 28.934 0l6.796 4.248a40.001 40.001 0 0 0-3.738 7.533c-.944 2.606-1.416 5.551-1.416 8.836v7.76H18.852Z"
    }, null, -1)
  ])))
}
export default { render: render }